import React from "react";
import {
  DateFormatsTypes,
  MomentDate,
} from "../../../../../../components/Moment/Moment";

const TopSection = (props: Record<string, any>): React.JSX.Element => {
  // shows date
  // OR if game is live shows score
  const { eventData, scoreFullTime, isEventLive } = props;
  return (
    <div className="asian-event__time-section--top">
      {isEventLive ? (
        scoreFullTime
      ) : (
        <MomentDate
          dateFormat={DateFormatsTypes.DATE_MDD}
          value={eventData["startTime"]}
        />
      )}
    </div>
  );
};

export default TopSection;
